import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "z-50 fixed w-full h-full top-0 left-0 flex justify-center items-center bg-black bg-opacity-60" }
const _hoisted_2 = { class: "bg-white shadow-modal rounded-md p-11 w-modal text-3xl leading-snug" }
const _hoisted_3 = { class: "text-modal-text text-center font-semibold pb-10" }

import { onMounted, onUnmounted } from "vue";

interface Props {
  timeout?: number; // Time after which component will send event to close the modal
}

interface Emits {
  (e: "closeOnTimeout"): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    timeout: null
  },
  emits: ["closeOnTimeout"],
  setup(__props: any, { emit }: { emit: ({
  (e: "closeOnTimeout"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  timeout?: number; // Time after which component will send event to close the modal
}




let closeTimer: ReturnType<typeof setTimeout> | null = null;

onUnmounted(() => {
  if (closeTimer) {
    clearTimeout(closeTimer);
  }
});

onMounted(() => {
  if (props.timeout) {
    closeTimer = setTimeout(() => {
      emit("closeOnTimeout");
    }, props.timeout);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "message")
      ]),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "actions")
      ])
    ])
  ]))
}
}

})